<template>
  <div v-show="availableLocales.includes($i18n.locale)" class="chatbot-link" :class="{ 'chatbot-link-active': active, 'bnw-gray': blackAndWhite }">
    <div class="chatbot-link-overlay" @click="active = false">
    </div>
    <div class="chatbot-link-dialog">
      <div class="chatbot-link-dialog-header">
        <h1 class="chatbot-link-dialog-makmak">{{ $t('chatbot.popupTitle') || 'chatbot.popupTitle' }}</h1>
        <img class="chatbot-link-dialog-avatar" src="/static/chatbot/avatar_makmak.png" width="100" height="100" alt="" />
      </div>
      <div class="chatbot-link-dialog-body">
        <h2>{{ $t('chatbot.terms') || 'chatbot.terms' }}</h2>
        <p v-html="$t('chatbot.termsDetails') || 'chatbot.termsDetails'"></p>
        <a role="button" class="chatbot-link-btn cx-btn" :href="link" target="_blank" @click="active = false">{{ $t('chatbot.continue') || 'chatbot.continue' }}</a>
      </div>
    </div>
    <button class="chatbot-link-toggle" @click="active = !active">
      <img class="chatbot-link-toggle-avatar" src="/static/chatbot/avatar_makmak.png" width="100%" height="100%" alt="" />
      <div class="chatbot-link-toggle-bubble-wrap" v-if="$t('chatbot.iconTitle')">
        <span class="chatbot-link-toggle-bubble">{{ $t('chatbot.iconTitle') || 'chatbot.iconTitle' }}</span>
      </div>
      <!-- <svg class="chatbot-link-toggle-dot" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.4321 9.4451L10.4321 9.44507L10.4331 9.44452C10.715 9.28652 11.0714 9.08668 11.3441 8.83363C11.6673 8.53361 11.927 8.11187 11.927 7.54531C11.927 6.77931 11.4375 6.25984 11.0125 5.98373C10.5798 5.70261 10.0446 5.5486 9.545 5.5486C8.94682 5.5486 8.44359 5.70109 7.99733 6.01507C7.78394 6.16521 7.59601 6.34502 7.4272 6.53072L7.36955 6.48701C7.61018 6.21072 7.8602 6.00211 8.12766 5.84882C8.52616 5.62044 9.02428 5.47984 9.70126 5.47984C10.3073 5.47984 10.966 5.72247 11.4656 6.13529C11.9609 6.54457 12.2254 7.05283 12.2254 7.56452C12.2254 7.95113 12.1258 8.19201 12.0073 8.36509C11.8775 8.55449 11.6861 8.71881 11.4236 8.889C11.2921 8.97422 11.158 9.05163 11.007 9.13874L11.0058 9.13945L10.9981 9.14388C10.8593 9.22398 10.6912 9.32099 10.5394 9.42448C10.3627 9.54495 10.0248 9.79142 9.83936 10.1935H9.42648C9.46523 10.1334 9.51103 10.079 9.56231 10.027C9.76757 9.8186 10.0437 9.6628 10.4321 9.4451ZM7.02676 7.01203C7.02685 7.01193 7.02693 7.01182 7.02702 7.01171L7.02676 7.01203ZM9.5 18C14.194 18 18 14.1954 18 9.5C18 4.80718 14.1942 1 9.5 1C4.80577 1 1 4.80718 1 9.5C1 14.1954 4.80598 18 9.5 18ZM9.10887 13.371C9.10887 13.1562 9.2852 12.9798 9.5 12.9798C9.7148 12.9798 9.89113 13.1562 9.89113 13.371C9.89113 13.5858 9.71479 13.7621 9.5 13.7621C9.28521 13.7621 9.10887 13.5858 9.10887 13.371Z" fill="#D7192E" stroke="#F9F7F4" stroke-width="2"/>
      </svg> -->
      <svg class="chatbot-link-toggle-close" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.8516 8.59375L16.7378 3.70752C17.3374 3.10791 17.3374 2.13574 16.7378 1.53564L15.6519 0.449707C15.0522 -0.149902 14.0801 -0.149902 13.48 0.449707L8.59375 5.33594L3.70752 0.449707C3.10791 -0.149902 2.13574 -0.149902 1.53564 0.449707L0.449707 1.53564C-0.149902 2.13525 -0.149902 3.10742 0.449707 3.70752L5.33594 8.59375L0.449707 13.48C-0.149902 14.0796 -0.149902 15.0518 0.449707 15.6519L1.53564 16.7378C2.13525 17.3374 3.10791 17.3374 3.70752 16.7378L8.59375 11.8516L13.48 16.7378C14.0796 17.3374 15.0522 17.3374 15.6519 16.7378L16.7378 15.6519C17.3374 15.0522 17.3374 14.0801 16.7378 13.48L11.8516 8.59375Z" fill="white"/>
      </svg>
    </button>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'chatbot-link',
  uit() {
    return [
      ['chatbot', ['terms', 'termsDetails', 'continue', 'popupTitle', 'iconTitle']]
    ]
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    ...mapState({
      blackAndWhite: state => state.ui.blackAndWhite,
    }),
    availableLocales() {
      return [
        'zh-hant',
        'zh-hans',
        'pt',
        'en',
        'ja',
        'ko',
        'th',
        // 'id',
        // 'hi',
      ];
    },
    link() {
      return `https://chat.macaotourism.gov.mo${this.availableLocales.includes(this.$i18n.locale) ? ('/' + this.$i18n.locale) : ''}?opener=mkt`;
    },
  },
  watch: {
    active(active) {
      if (active) {
        document.body.style.setProperty('overflow', 'hidden');
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.chatbot-link {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10002;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 15px 20px;
  pointer-events: none;
}
.chatbot-link > * {
  pointer-events: auto;
}

.chatbot-link-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  width: 100%;
  height: 100%;
  background: rgba(211, 211, 211, 0.8);
  display: none;
}

.chatbot-link-toggle:hover {
  cursor: pointer;
}
.chatbot-link-toggle {
  position: relative;
  z-index: 1;
  /* margin-bottom: 15px; */
  /* margin-right: 20px; */
  /* bottom: 15px; */
  /* right: 20px; */
  appearance: none;
  outline: none;
  border: 2px solid #ffffff;
  width: 90px;
  height: 90px;
  flex-shrink: 0;
  border-radius: 50%;
  box-shadow: 0px 4px 70px rgba(0, 0, 0, 0.25);
  filter: drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.25));
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.chatbot-link-toggle-avatar {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  transform: scaleX(-1);
}
.chatbot-link-toggle-bubble-wrap {
  position: absolute;
  top: -32px;
  right: -1px;
  z-index: 1;
  min-width: 90px;
}
.chatbot-link-toggle-bubble {
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  padding: 3px 8px;
  color: #3D4649;
  background: #F9F7F4;
  box-shadow: 0px 4px 70px rgba(0, 0, 0, 0.25);
  border-radius: 100px;
}
.chatbot-link-toggle-dot {
  position: absolute;
  top: 0;
  right: 0;
}
.chatbot-link-toggle-close {
  position: absolute;
  display: none;
}

.chatbot-link-dialog {
  display: none;
  position: relative;
  margin-bottom: 20px;
  /* margin-right: 20px; */
  /* bottom: 90px; */
  /* right: 20px; */
  width: 400px;
  max-width: 100%;
  max-height: 100%;
  overflow: auto;
  border-radius: 10px;
  box-shadow: 0px 4px 70px rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  letter-spacing: -0.025em;
}
.chatbot-link-dialog-header {
  position: relative;
  width: 100%;
  height: 100px;
  padding: 0 32px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #ffffff;
  background-image: url('/static/chatbot/bg_pattern.png');
  background-position: center;
  background-size: cover;
  background-repeat: repeat;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.chatbot-link-dialog-makmak {
  position: absolute;
  left: 30px;
  top: 46px;
  line-height: normal;
  font-weight: 700;
  font-size: 26px;
}
.chatbot-link-dialog-avatar {
  width: 100px;
  height: 100px;
  margin-bottom: -50px;
  margin-right: 5px;
  border-radius: 50%;
  /* border: 10px solid #ffffff; */
  box-shadow: 0px 0px 0px 10px #ffffff;
  background-color: white;
}
.chatbot-link-dialog-body {
  padding: 32px;
  padding-top: 44px;
  font-size: 16px;
  width: 100%;
  height: auto;
  background: #ffffff;
}
.chatbot-link-dialog-body h2 {
  text-align: left;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 14px;
}
.chatbot-link-dialog-body a:hover {
  text-decoration: underline;
}
.chatbot-link-dialog-body a.chatbot-link-btn:hover {
  text-decoration: none;
}
.chatbot-link-dialog-body a.chatbot-link-btn {
  appearance: none;
  border: none;
  outline: none;
  display: block;
  width: 100%;
  padding: 10px;
  margin-top: 40px;
  border-radius: 5px;
  background-color: $color-green;
  color: white;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
}

.chatbot-link-active .chatbot-link-overlay {
  display: block;
}
.chatbot-link-active .chatbot-link-dialog {
  display: block;
}
.chatbot-link-active .chatbot-link-toggle {
  border-color: #231F20;
  background-color: #231F20;
  background-image: none;
}
.chatbot-link-active .chatbot-link-toggle-avatar {
  display: none;
}
.chatbot-link-active .chatbot-link-toggle-bubble {
  display: none;
}
.chatbot-link-active .chatbot-link-toggle-dot {
  display: none;
}
.chatbot-link-active .chatbot-link-toggle-close {
  display: block;
}

@media (max-width: 768px) {
  .chatbot-link {
    font-size: 0.9em;
  }
  .chatbot-link-toggle {
    width: 60px;
    height: 60px;
  }
  .chatbot-link-dialog {
    letter-spacing: -0.05em;
  }
  .chatbot-link-dialog-avatar {
    width: 96px;
    height: 96px;
    margin-bottom: -48px;
    margin-right: 4px;
    /* border: 8px solid #ffffff; */
    box-shadow: 0px 0px 0px 8px #ffffff;
  }
  .chatbot-link-dialog-body {
    padding-top: 40px;
  }
  .chatbot-link-dialog-body h2 {
    font-size: 16px;
    margin-bottom: 14px;
  }
  .chatbot-link-dialog-body a.chatbot-link-btn {
    margin-top: 25px;
    padding: 8px;
    font-size: 18px;
  }
  .chatbot-link-toggle-bubble {
    top: -24px;
    right: -2px;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
  }
}
</style>
